module.exports = __webpack_public_path__ + "img/svg/challenges.948ea185597d9157516514cd9d648eb2.svg";